(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    // Marks which half of a carousel the mouse is over, so only that side's arrow shows (see the stylesheet above).
  (() => {
    const selector = 'slideshow-component.carousel-content';
    /** @type {HTMLElement | null} */
    let active = null;

    const clear = () => {
      active?.removeAttribute('data-hover-side');
      active = null;
    };

    document.addEventListener(
      'pointermove',
      (event) => {
        if (event.pointerType !== 'mouse') return;

        const carousel = event.target instanceof Element ? event.target.closest(selector) : null;
        if (carousel !== active) clear();
        if (!(carousel instanceof HTMLElement)) return;

        const { left, width } = carousel.getBoundingClientRect();
        carousel.dataset.hoverSide = event.clientX < left + width / 2 ? 'previous' : 'next';
        active = carousel;
      },
      { passive: true }
    );

    // The mouse leaving the window doesn't fire pointermove, so clear explicitly.
    document.documentElement.addEventListener('mouseleave', clear);
  })();
  } catch(e) { console.error(e); }
})();

})();
